var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-cart__details" }, [
    _c("table", { staticClass: "sidebar-cart__details-table" }, [
      _c("thead", { staticClass: "sidebar-cart__details-table-head" }, [
        _c("tr", { staticClass: "sidebar-cart__details-table-row" }, [
          _c("th", { staticClass: "sidebar-cart__details-table-header" }),
          _vm._v(" "),
          _c("th", {
            staticClass: "sidebar-cart__details-table-header",
            domProps: { innerHTML: _vm._s(_vm.$t("cart.details.calories")) }
          }),
          _vm._v(" "),
          _c("th", {
            staticClass: "sidebar-cart__details-table-header",
            domProps: { innerHTML: _vm._s(_vm.$t("cart.details.co2")) }
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        { staticClass: "sidebar-cart__details-table-body" },
        [
          _vm._l(_vm.items, function(item) {
            return _c(
              "tr",
              {
                key: "details-item-" + item.id,
                staticClass: "sidebar-cart__details-table-row"
              },
              [
                _c("td", { staticClass: "sidebar-cart__details-table-cell" }, [
                  _c("span", {
                    staticClass: "sidebar-cart__details-name",
                    domProps: { innerHTML: _vm._s(item.name) }
                  }),
                  _vm._v(" "),
                  item.variant
                    ? _c("span", {
                        staticClass: "sidebar-cart__details-meta",
                        domProps: { innerHTML: _vm._s(item.variant) }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("td", {
                  staticClass: "sidebar-cart__details-table-cell",
                  domProps: { innerHTML: _vm._s(item.nutrient.calories) }
                }),
                _vm._v(" "),
                _c("td", {
                  staticClass: "sidebar-cart__details-table-cell",
                  domProps: { innerHTML: _vm._s(item.co2.emission) }
                })
              ]
            )
          }),
          _vm._v(" "),
          _vm.hasFeature("FEATURE_ADDITIONALPRODUCTS") &&
          _vm.additionalItemsAvailable &&
          _vm.totalItemsWithoutAdditional
            ? _c("tr", { staticClass: "sidebar-cart__details-table-row" }, [
                _c("td", { staticClass: "sidebar-cart__details-table-cell" }, [
                  _c("span", {
                    staticClass: "sidebar-cart__details-name",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("cart.additionalProducts.title"))
                    }
                  })
                ]),
                _vm._v(" "),
                _c("td", {
                  staticClass: "sidebar-cart__details-table-cell",
                  domProps: {
                    innerHTML: _vm._s(_vm.additionalItemsTotalNutrient.calories)
                  }
                }),
                _vm._v(" "),
                _c("td", {
                  staticClass: "sidebar-cart__details-table-cell",
                  domProps: {
                    innerHTML: _vm._s(_vm.additionalItemsTotalCo2.emission)
                  }
                })
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("tfoot", { staticClass: "sidebar-cart__details-table-foot" }, [
        _c("tr", { staticClass: "sidebar-cart__details-table-row" }, [
          _c("td", { staticClass: "sidebar-cart__details-table-footer" }, [
            _c("span", {
              staticClass: "sidebar-cart__details-total",
              domProps: { innerHTML: _vm._s(_vm.$t("cart.details.total")) }
            })
          ]),
          _vm._v(" "),
          _c("td", {
            staticClass: "sidebar-cart__details-table-footer",
            domProps: { innerHTML: _vm._s(_vm.totalNutrient.calories) }
          }),
          _vm._v(" "),
          _c("td", {
            staticClass: "sidebar-cart__details-table-footer",
            domProps: { innerHTML: _vm._s(_vm.totalCo2.emission) }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }